import type { LoginAvailabilityDto } from '@nomiss/sdk';
import {
  ApiRequestError,
  executeSdkRawRequest,
} from './api-request.util';
import { authenticationApi } from './sdk-client';

export type LoginAvailabilityPayload = {
  phone?: string;
  email?: string;
};

export type LoginAvailabilityResult = {
  accountExists: boolean;
};

export class LoginAvailabilityError extends ApiRequestError {
  constructor(status: number, message: string) {
    super(status, message, 'LoginAvailabilityError');
  }
}

export async function checkLoginAvailability(
  payload: LoginAvailabilityPayload,
): Promise<LoginAvailabilityResult> {
  const dto: LoginAvailabilityDto = {};
  if (payload.phone) {
    dto.phone = payload.phone;
  }
  if (payload.email) {
    dto.email = payload.email.trim().toLowerCase();
  }

  return executeSdkRawRequest({
    request: () =>
      authenticationApi.authControllerCheckLoginAvailabilityV1Raw({
        loginAvailabilityDto: dto,
      }),
    fallback: 'Login availability check failed',
    ErrorClass: LoginAvailabilityError,
  });
}
